// Role-based navigation configuration
// This defines what each user role can see and access

export const roleNavigationConfig = {
  system_admin: {
    dashboard: {
      title: 'System Administration Dashboard',
      widgets: ['system_stats', 'user_activity', 'member_overview', 'approval_queue', 'system_health']
    },
    navigation: [
      { path: '/app/dashboard', label: 'Dashboard', icon: 'Home', permission: 'view_dashboard' },
      { path: '/app/members', label: 'All Members', icon: 'Users', permission: 'view_members' },
      // Draft Members removed - direct membership on approval
      { path: '/app/members/pending', label: 'Pending Approval', icon: 'Clock', permission: 'approve_members' },

      // Membership section
      { type: 'section', label: 'Membership Section', icon: 'Users', permission: 'view_members' },
      { path: '/app/membership-applications/forms', label: 'Membership Applications', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/membership-applications/submissions', label: 'Application Submissions', icon: 'FileCheck', permission: 'view_forms' },
      { path: '/application-status', label: 'Application Status Page', icon: 'FileSearch', permission: 'view_forms' },

      // Training & events management
      { path: '/app/training', label: 'Training Programs', icon: 'GraduationCap', permission: 'view_training' },
      { path: '/app/training/manage', label: 'Manage Training', icon: 'GraduationCap', permission: 'manage_training' },
      { path: '/app/training/certificate-settings', label: 'Certificate Settings', icon: 'Settings', permission: 'manage_training' },

      // Announcement section
      { type: 'section', label: 'Announcement Section', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/news', label: 'News', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/events', label: 'Events', icon: 'Calendar', permission: 'view_events' },
      { path: '/app/events/manage', label: 'Manage Events', icon: 'Calendar', permission: 'manage_events' },
      { path: '/app/gallery', label: 'Gallery', icon: 'Camera', permission: 'view_gallery' },

      // Content & donate
      { path: '/app/publications', label: 'Publications', icon: 'BookOpen', permission: 'view_publications' },
      { path: '/app/about', label: 'About Us', icon: 'Info', permission: 'view_about' },
      { path: '/app/testimonials', label: 'Testimonials', icon: 'MessageSquare', permission: 'view_about' },
      { path: '/app/partners', label: 'Partners', icon: 'Building2', permission: 'view_about' },
      { path: '/app/donation-bank-accounts', label: 'Donate', icon: 'Heart', permission: 'view_about' },

      // Tools & communication
      { path: '/app/forms', label: 'Form Builder', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/chat', label: 'Chat', icon: 'MessageCircle', permission: 'use_chat' },
      { path: '/app/jobs', label: 'Jobs', icon: 'Briefcase', permission: 'view_forms' },
      { path: '/app/surveys/manage', label: 'Surveys', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/reports', label: 'Reports', icon: 'BarChart3', permission: 'view_reports' },

      // Contact & system settings
      { path: '/app/contact/messages', label: 'Contact Messages', icon: 'Mail', permission: 'view_messages' },
      { path: '/app/contact/settings', label: 'Contact Settings', icon: 'Settings', permission: 'view_settings' },
      { path: '/app/admin/email-settings', label: 'Email', icon: 'Mail', permission: 'view_settings' },
      { path: '/app/admin/users', label: 'User Management', icon: 'Shield', permission: 'view_users' },
      { path: '/app/admin/roles', label: 'Role & Permissions', icon: 'Shield', permission: 'view_users' },
      { path: '/app/admin/settings', label: 'System Settings', icon: 'Settings', permission: 'view_settings' },
      { path: '/app/admin/audit', label: 'Audit Logs', icon: 'FileSearch', permission: 'view_audit_logs' }
    ]
  },
  
  regional_coordinator: {
    dashboard: {
      title: 'Regional Coordination Dashboard',
      widgets: ['regional_stats', 'pending_approvals', 'recent_activity', 'training_progress', 'member_growth']
    },
    navigation: [
      { path: '/app/dashboard', label: 'Dashboard', icon: 'Home', permission: 'view_dashboard' },
      { path: '/app/members', label: 'Regional Members', icon: 'Users', permission: 'view_members' },
      { path: '/app/members/pending', label: 'Pending Review', icon: 'Clock', permission: 'approve_regional' },
      { path: '/app/training', label: 'Training Programs', icon: 'GraduationCap', permission: 'view_training' },
      { path: '/app/events', label: 'Events', icon: 'Calendar', permission: 'view_events' },
      { path: '/application-status', label: 'Application Status', icon: 'FileSearch', permission: 'view_forms' },
      { path: '/app/news', label: 'News', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/publications', label: 'Publications', icon: 'BookOpen', permission: 'view_publications' },
      { path: '/app/gallery', label: 'Gallery', icon: 'Camera', permission: 'view_gallery' },
      { path: '/app/forms', label: 'Forms', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/chat', label: 'Chat', icon: 'MessageCircle', permission: 'use_chat' },
      { path: '/app/membership-applications/forms', label: 'Membership Applications', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/membership-applications/submissions', label: 'Application Submissions', icon: 'FileCheck', permission: 'view_forms' },
      { path: '/app/jobs', label: 'Jobs', icon: 'Briefcase', permission: 'view_forms' },
      { path: '/app/membership-applications/import', label: 'Import Applications (CSV)', icon: 'Upload', permission: 'view_forms' },
      // Draft Members removed - direct membership on approval
      { path: '/app/reports', label: 'Regional Reports', icon: 'BarChart3', permission: 'view_reports' }
    ]
  },
  
  data_entry_officer: {
    dashboard: {
      title: 'Data Entry Dashboard',
      widgets: ['my_tasks', 'recent_submissions', 'approval_status', 'training_opportunities', 'quick_actions']
    },
    navigation: [
      { path: '/app/dashboard', label: 'Dashboard', icon: 'Home', permission: 'view_dashboard' },
      { path: '/app/members', label: 'Members', icon: 'Users', permission: 'view_members' },
      // Draft Members removed - direct membership on approval
      { path: '/app/members/add', label: 'Add Member', icon: 'UserPlus', permission: 'add_members' },
      { path: '/app/training', label: 'Training Programs', icon: 'GraduationCap', permission: 'view_training' },
      { path: '/app/events', label: 'Events', icon: 'Calendar', permission: 'view_events' },
      { path: '/application-status', label: 'Application Status', icon: 'FileSearch', permission: 'view_forms' },
      { path: '/app/news', label: 'News', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/publications', label: 'Publications', icon: 'BookOpen', permission: 'view_publications' },
      { path: '/app/gallery', label: 'Gallery', icon: 'Camera', permission: 'view_gallery' },
      { path: '/app/forms', label: 'Forms', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/chat', label: 'Chat', icon: 'MessageCircle', permission: 'use_chat' },
      { path: '/app/membership-applications/forms', label: 'Membership Applications', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/membership-applications/submissions', label: 'Application Submissions', icon: 'FileCheck', permission: 'view_forms' },
      { path: '/app/jobs', label: 'Jobs', icon: 'Briefcase', permission: 'view_forms' }
    ]
  },
  
  program_officer: {
    dashboard: {
      title: 'Program Management Dashboard',
      widgets: ['program_stats', 'training_analytics', 'event_metrics', 'member_engagement', 'donor_reports']
    },
    navigation: [
      { path: '/app/dashboard', label: 'Dashboard', icon: 'Home', permission: 'view_dashboard' },
      { path: '/app/members', label: 'Members Overview', icon: 'Users', permission: 'view_members' },
      { path: '/app/training', label: 'Training Analytics', icon: 'GraduationCap', permission: 'view_training' },
      { path: '/app/events', label: 'Events', icon: 'Calendar', permission: 'view_events' },
      { path: '/application-status', label: 'Application Status', icon: 'FileSearch', permission: 'view_forms' },
      { path: '/app/news', label: 'News', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/publications', label: 'Publications', icon: 'BookOpen', permission: 'view_publications' },
      { path: '/app/gallery', label: 'Gallery', icon: 'Camera', permission: 'view_gallery' },
      { path: '/app/chat', label: 'Chat', icon: 'MessageCircle', permission: 'use_chat' },
      { path: '/app/reports', label: 'Reports & Analytics', icon: 'BarChart3', permission: 'view_reports' },
      { path: '/app/reports/export', label: 'Export Data', icon: 'Download', permission: 'export_reports' }
    ]
  },
  
  member: {
    dashboard: {
      title: 'My Profile Dashboard',
      widgets: ['my_profile', 'my_trainings', 'my_events', 'my_certificates', 'upcoming_opportunities']
    },
    navigation: [
      { path: '/app/dashboard', label: 'My Dashboard', icon: 'Home', permission: 'view_own_profile' },
      { path: '/app/profile', label: 'My Profile', icon: 'User', permission: 'view_own_profile' },
      { path: '/app/trainings', label: 'My Trainings', icon: 'GraduationCap', permission: 'view_own_trainings' },
      { path: '/app/news', label: 'News', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/publications', label: 'Publications', icon: 'BookOpen', permission: 'view_publications' },
      { path: '/app/gallery', label: 'Gallery', icon: 'Camera', permission: 'view_gallery' },
      { path: '/app/chat', label: 'Chat', icon: 'MessageCircle', permission: 'use_chat' },
      { path: '/app/certificates', label: 'My Certificates', icon: 'Award', permission: 'view_own_certificates' }
    ]
  },
  
  super_admin: {
    dashboard: {
      title: 'Super Administrator Dashboard',
      widgets: ['system_overview', 'performance_metrics', 'security_alerts', 'backup_status', 'maintenance_tasks']
    },
    navigation: [
      { path: '/app/dashboard', label: 'System Dashboard', icon: 'Home', permission: 'view_dashboard' },
      { path: '/app/members', label: 'All Members', icon: 'Users', permission: 'view_members' },

      // Membership section
      { type: 'section', label: 'Membership Section', icon: 'Users', permission: 'view_members' },
      { path: '/app/membership-applications/forms', label: 'Membership Applications', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/membership-applications/submissions', label: 'Application Submissions', icon: 'FileCheck', permission: 'view_forms' },
      { path: '/application-status', label: 'Application Status Page', icon: 'FileSearch', permission: 'view_forms' },

      // Training & events
      { path: '/app/training', label: 'Training Programs', icon: 'GraduationCap', permission: 'view_training' },

      // Announcement section
      { type: 'section', label: 'Announcement Section', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/news', label: 'News', icon: 'Newspaper', permission: 'view_news' },
      { path: '/app/events', label: 'Events', icon: 'Calendar', permission: 'view_events' },
      { path: '/app/events/manage', label: 'Manage Events', icon: 'Calendar', permission: 'manage_events' },
      { path: '/app/gallery', label: 'Gallery', icon: 'Camera', permission: 'view_gallery' },

      // Content & donate
      { path: '/app/publications', label: 'Publications', icon: 'BookOpen', permission: 'view_publications' },
      { path: '/app/about', label: 'About Us', icon: 'Info', permission: 'view_about' },
      { path: '/app/testimonials', label: 'Testimonials', icon: 'MessageSquare', permission: 'view_about' },
      { path: '/app/partners', label: 'Partners', icon: 'Building2', permission: 'view_about' },
      { path: '/app/donation-bank-accounts', label: 'Donate', icon: 'Heart', permission: 'view_about' },

      // Tools & communication
      { path: '/app/forms', label: 'Form Builder', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/chat', label: 'Chat', icon: 'MessageCircle', permission: 'use_chat' },
      { path: '/app/jobs', label: 'Jobs', icon: 'Briefcase', permission: 'view_forms' },
      { path: '/app/surveys/manage', label: 'Surveys', icon: 'FileText', permission: 'view_forms' },
      { path: '/app/reports', label: 'Reports', icon: 'BarChart3', permission: 'view_reports' },

      // Contact & admin tools
      { path: '/app/contact/messages', label: 'Contact Messages', icon: 'Mail', permission: 'view_messages' },
      { path: '/app/contact/settings', label: 'Contact Settings', icon: 'Settings', permission: 'view_settings' },
      { path: '/app/admin/email-settings', label: 'Email', icon: 'Mail', permission: 'view_settings' },
      { path: '/app/admin/users', label: 'User Management', icon: 'Shield', permission: 'view_users' },
      { path: '/app/admin/roles', label: 'Role & Permissions', icon: 'Shield', permission: 'view_users' },
      { path: '/app/admin/settings', label: 'System Settings', icon: 'Settings', permission: 'view_settings' },
      { path: '/app/admin/audit', label: 'Audit Logs', icon: 'FileSearch', permission: 'view_audit_logs' },
      { path: '/app/admin/maintenance', label: 'System Maintenance', icon: 'Wrench', permission: 'system_maintenance' },
      { path: '/app/admin/backup', label: 'Backup & Restore', icon: 'Database', permission: 'database_backup' }
    ]
  }
};

// Dashboard widget configurations
export const dashboardWidgets = {
  // System Admin widgets
  system_stats: {
    title: 'System Statistics',
    component: 'SystemStatsWidget',
    size: 'large',
    permissions: ['view_system_stats']
  },
  user_activity: {
    title: 'User Activity',
    component: 'UserActivityWidget',
    size: 'medium',
    permissions: ['view_user_activity']
  },
  member_overview: {
    title: 'Member Overview',
    component: 'MemberOverviewWidget',
    size: 'large',
    permissions: ['view_members']
  },
  approval_queue: {
    title: 'Approval Queue',
    component: 'ApprovalQueueWidget',
    size: 'medium',
    permissions: ['approve_members']
  },
  system_health: {
    title: 'System Health',
    component: 'SystemHealthWidget',
    size: 'small',
    permissions: ['view_system_health']
  },
  
  // Regional Coordinator widgets
  regional_stats: {
    title: 'Regional Statistics',
    component: 'RegionalStatsWidget',
    size: 'large',
    permissions: ['view_regional_stats']
  },
  pending_approvals: {
    title: 'Pending Approvals',
    component: 'PendingApprovalsWidget',
    size: 'medium',
    permissions: ['approve_regional']
  },
  recent_activity: {
    title: 'Recent Activity',
    component: 'RecentActivityWidget',
    size: 'medium',
    permissions: ['view_recent_activity']
  },
  training_progress: {
    title: 'Training Progress',
    component: 'TrainingProgressWidget',
    size: 'small',
    permissions: ['view_training']
  },
  member_growth: {
    title: 'Member Growth',
    component: 'MemberGrowthWidget',
    size: 'small',
    permissions: ['view_members']
  },
  
  // Data Entry Officer widgets
  my_tasks: {
    title: 'My Tasks',
    component: 'MyTasksWidget',
    size: 'medium',
    permissions: ['view_own_tasks']
  },
  recent_submissions: {
    title: 'Recent Submissions',
    component: 'RecentSubmissionsWidget',
    size: 'medium',
    permissions: ['view_own_submissions']
  },
  approval_status: {
    title: 'Approval Status',
    component: 'ApprovalStatusWidget',
    size: 'small',
    permissions: ['view_own_approval_status']
  },
  training_opportunities: {
    title: 'Training Opportunities',
    component: 'TrainingOpportunitiesWidget',
    size: 'small',
    permissions: ['view_training']
  },
  quick_actions: {
    title: 'Quick Actions',
    component: 'QuickActionsWidget',
    size: 'small',
    permissions: ['add_members']
  },
  
  // Program Officer widgets
  program_stats: {
    title: 'Program Statistics',
    component: 'ProgramStatsWidget',
    size: 'large',
    permissions: ['view_program_stats']
  },
  training_analytics: {
    title: 'Training Analytics',
    component: 'TrainingAnalyticsWidget',
    size: 'medium',
    permissions: ['view_training']
  },
  event_metrics: {
    title: 'Event Metrics',
    component: 'EventMetricsWidget',
    size: 'medium',
    permissions: ['view_events']
  },
  member_engagement: {
    title: 'Member Engagement',
    component: 'MemberEngagementWidget',
    size: 'small',
    permissions: ['view_members']
  },
  donor_reports: {
    title: 'Donor Reports',
    component: 'DonorReportsWidget',
    size: 'small',
    permissions: ['view_reports']
  },
  
  // Member widgets
  my_profile: {
    title: 'My Profile',
    component: 'MyProfileWidget',
    size: 'medium',
    permissions: ['view_own_profile']
  },
  my_trainings: {
    title: 'My Trainings',
    component: 'MyTrainingsWidget',
    size: 'medium',
    permissions: ['view_own_trainings']
  },
  my_events: {
    title: 'My Events',
    component: 'MyEventsWidget',
    size: 'small',
    permissions: ['view_own_events']
  },
  my_certificates: {
    title: 'My Certificates',
    component: 'MyCertificatesWidget',
    size: 'small',
    permissions: ['view_own_certificates']
  },
  upcoming_opportunities: {
    title: 'Upcoming Opportunities',
    component: 'UpcomingOpportunitiesWidget',
    size: 'small',
    permissions: ['view_training', 'view_events']
  },
  
  // Super Admin widgets
  system_overview: {
    title: 'System Overview',
    component: 'SystemOverviewWidget',
    size: 'large',
    permissions: ['view_system_overview']
  },
  performance_metrics: {
    title: 'Performance Metrics',
    component: 'PerformanceMetricsWidget',
    size: 'medium',
    permissions: ['view_performance_metrics']
  },
  security_alerts: {
    title: 'Security Alerts',
    component: 'SecurityAlertsWidget',
    size: 'small',
    permissions: ['view_security_alerts']
  },
  backup_status: {
    title: 'Backup Status',
    component: 'BackupStatusWidget',
    size: 'small',
    permissions: ['database_backup']
  },
  maintenance_tasks: {
    title: 'Maintenance Tasks',
    component: 'MaintenanceTasksWidget',
    size: 'small',
    permissions: ['system_maintenance']
  }
};

// Helper functions
export const getUserNavigation = (userRole) => {
  return roleNavigationConfig[userRole]?.navigation || [];
};

export const getUserDashboard = (userRole) => {
  return roleNavigationConfig[userRole]?.dashboard || {};
};

export const getUserWidgets = (userRole) => {
  const dashboard = getUserDashboard(userRole);
  return dashboard.widgets || [];
};

export const hasNavigationPermission = (userRole, permission) => {
  const navigation = getUserNavigation(userRole);
  return navigation.some(item => item.permission === permission);
};

export default roleNavigationConfig;
